import React from 'react'
import styled, { css } from 'styled-components'
import {
  CouponPurchaseProps,
  paymentRadioButtonItemsType,
} from 'src/pages/CouponPurchasePage/index'
import { layoutMaxSize, ZIndex } from 'src/styles/mixin'
import Button, { ButtonOption3 } from 'src/components/common/Button'
import { Container } from 'src/components/common/Container'
import PurchaseCouponInfo from 'src/pages/CouponPurchasePage/_components/PurchaseCouponInfo'
import {
  Noto_body1_m16,
  Noto_body1_r16,
  Noto_body2_b14,
  Noto_body2_r14,
  Noto_body3_m12,
} from 'src/styles/fonts/NotoSansKrFonts'
import { Typography } from 'src/components/common/Typography'
import { Divider, SmallDivider } from 'src/components/common/Divider'
import RenderIf from 'src/components/common/RenderIf'
import useParamsType from 'src/hooks/useParamsType.hook'

const CouponPurchaseView = (props: CouponPurchaseProps) => {
  const {
    isSubmiting,
    radioButtonItems,
    handlePaymentCallSubmit,
    handleServiceTermsModal,
    handleSetPaymentMethod,
    activePaymentMethod,
    couponDetailData,
  } = props
  const { couponType } = useParamsType()
  const hotdeal = couponType === '1'

  const generalItems = radioButtonItems?.filter((item) => item.group === 'general') ?? []
  const easyItems = radioButtonItems?.filter((item) => item.group === 'easy') ?? []
  const easyCols = easyItems.length <= 2 ? 2 : 3

  return (
    <S.CouponPurchase.Container $option="flex_column" $row_gap="30px">
      {/*구매 쿠폰 정보*/}
      <PurchaseCouponInfo {...props} />
      <Divider />
      {/*결제수단*/}
      <S.CouponPurchase.PaymentMethod.Container $option="flex_column" $row_gap="14px">
        <Typography $fontStyle={Noto_body1_m16}>결제수단</Typography>
        <S.CouponPurchase.PaymentMethod.Form>
      

          <S.CouponPurchase.PaymentMethod.Section $option="flex_column" $row_gap="14px">
            <Typography $fontStyle={Noto_body1_m16} $color="var(--black-50)">
              간편결제
            </Typography>
            <S.CouponPurchase.PaymentMethod.EasyGrid $cols={easyCols}>
              {easyItems.map(({ img, group: _group, ...rest }: paymentRadioButtonItemsType) => {
                const isActive = activePaymentMethod === rest.id
                return (
                  <S.CouponPurchase.PaymentMethod.FormItems key={rest.id} $active={isActive}>
                    <S.CouponPurchase.PaymentMethod.Radio
                      {...rest}
                      checked={isActive}
                      onChange={handleSetPaymentMethod}
                    />
                    <S.CouponPurchase.PaymentMethod.Label htmlFor={rest.id}>
                      {Boolean(img.src) ? (
                        <S.CouponPurchase.PaymentMethod.Image {...img} />
                      ) : (
                        <Typography $fontStyle={Noto_body1_r16}>{img.alt}</Typography>
                      )}
                    </S.CouponPurchase.PaymentMethod.Label>
                  </S.CouponPurchase.PaymentMethod.FormItems>
                )
              })}
            </S.CouponPurchase.PaymentMethod.EasyGrid>
          </S.CouponPurchase.PaymentMethod.Section>
          <S.CouponPurchase.PaymentMethod.Section $option="flex_column" $row_gap="14px">
          <Typography $fontStyle={Noto_body1_m16} $color="var(--black-50)">
              일반결제
            </Typography>
            <S.CouponPurchase.PaymentMethod.GeneralList>
              {generalItems.map(({ img, group: _group, ...rest }: paymentRadioButtonItemsType) => {
                const isActive = activePaymentMethod === rest.id
                return (
                  <S.CouponPurchase.PaymentMethod.GeneralItem key={rest.id}>
                    <S.CouponPurchase.PaymentMethod.GeneralLabel htmlFor={rest.id}>
                      <S.CouponPurchase.PaymentMethod.GeneralRadio
                        {...rest}
                        $isChecked={isActive}
                        checked={isActive}
                        onChange={handleSetPaymentMethod}
                      />
                      <Typography $fontStyle={Noto_body1_r16}>{img.alt}</Typography>
                    </S.CouponPurchase.PaymentMethod.GeneralLabel>
                  </S.CouponPurchase.PaymentMethod.GeneralItem>
                )
              })}
            </S.CouponPurchase.PaymentMethod.GeneralList>
          </S.CouponPurchase.PaymentMethod.Section>
        </S.CouponPurchase.PaymentMethod.Form>
      </S.CouponPurchase.PaymentMethod.Container>
      {/*약관*/}
      <S.CouponPurchase.Terms.Container $option="flex_column" $row_gap="14px">
        <SmallDivider />
        <Container $option="flex_column" $row_gap="4px">
          <Container $option="flex_row" $column_gap="6px">
            <Typography $fontStyle={Noto_body2_b14} $color="var(--black-70)">
              구매 및 개인정보 수집 및 이용 동의
            </Typography>
            <S.CouponPurchase.Terms.DetailChips onClick={handleServiceTermsModal}>
              상세보기
            </S.CouponPurchase.Terms.DetailChips>
          </Container>
          <Typography $fontStyle={Noto_body2_r14} $color="var(--black-50)">
            주문 내용을 확인하였으며, 구매 및 개인정보 수집 및 이용에 동의합니다.
          </Typography>
          <RenderIf when={hotdeal}>
            <Typography $fontStyle={Noto_body2_r14} $color="var(--black-50)">
              구매한 핫딜 상품을{' '}
              <Typography $fontStyle={Noto_body2_b14} $color="var(--red-30)">
                재판매
              </Typography>
              할 경우,{' '}
              <Typography $fontStyle={Noto_body2_b14} $color="var(--red-30)">
                회원 자격이 제한
              </Typography>
              될 수 있습니다.
            </Typography>
          </RenderIf>
        </Container>
      </S.CouponPurchase.Terms.Container>
      <S.CouponPurchase.Fixed.Container $option="flex_row">
        <Button
          option={ButtonOption3('active')}
          onClickFn={handlePaymentCallSubmit}
          disabled={isSubmiting || !couponDetailData?.SalePrice}
        >
          구매하기
        </Button>
      </S.CouponPurchase.Fixed.Container>
    </S.CouponPurchase.Container>
  )
}
export default CouponPurchaseView

const S = {
  CouponPurchase: {
    Container: styled(Container)``,
    Terms: {
      Container: styled(Container)<{ type?: 'terms' }>`
        padding: 0 20px 80px 20px;
        background-color: var(--white);
      `,
      DetailChips: styled.section`
        display: flex;
        border-radius: 30px;
        border: 1px solid var(--black-20);
        background: var(--white);
        ${Noto_body3_m12};
        color: var(--black-50);
        width: fit-content;
        cursor: pointer;
        align-items: center;
        padding: 1px 6px;
      `,
    },
    PaymentMethod: {
      Container: styled(Container)`
        padding: 0 20px;
        background-color: var(--white);
      `,
      Form: styled.form`
        display: flex;
        flex-direction: column;
        width: 100%;
        gap: 30px;
      `,
      Section: styled(Container)``,
      GeneralList: styled.div`
        display: flex;
        flex-direction: column;
        gap: 14px;
      `,
      GeneralItem: styled.div``,
      GeneralLabel: styled.label`
        display: flex;
        align-items: center;
        gap: 8px;
        cursor: pointer;
      `,
      GeneralRadio: styled.input.attrs({ type: 'radio', name: 'pay_method' })<{
        $isChecked: boolean
      }>`
        -webkit-appearance: none;
        appearance: none;
        position: relative;
        flex-shrink: 0;
        width: 22px;
        height: 22px;
        border-radius: 50%;
        border:1px solid var(--black-20);
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
        &::after {
          display: ${({ $isChecked }) => ($isChecked ? 'block' : 'none')};
          content: '';
          position: absolute;
          width: 10px;
          height: 10px;
          border-radius: 50%;
          background-color: var(--brand-50);
        }
      `,
      EasyGrid: styled.div<{ $cols?: number }>`
        display: grid;
        width: 100%;
        grid-template-columns: repeat(${({ $cols = 3 }) => $cols}, 1fr);
        gap: 6px;
      `,
      FormItems: styled.section<{ $active: boolean }>`
        border-radius: 12px;
        border: 1px solid var(--black-10);
        background: var(--white);

        ${(props) =>
          props.$active &&
          css`
            border: 1px solid var(--black-70);
            background: var(--black-4);
          `}
      `,
      Image: styled.img<{ size: string }>`
        display: flex;
        width: ${(props) => props.size};
        height: auto;
      `,
      Radio: styled.input.attrs({ type: 'radio' }).attrs({ name: 'pay_method' })`display: none;`,
      Label: styled.label`
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
        min-height: 48px;
        padding: 12px 16px;
      `,
    },
    Fixed: {
      Container: styled(Container)`
        ${layoutMaxSize};
        position: fixed;
        left: 50%;
        bottom: 0;
        padding: 10px;
        border-top: 1px solid var(--black-4);
        background-color: var(--white);
        transform: translate(-50%, 0%);
        z-index: ${ZIndex.BottomFixedContents};
      `,
    },
  },
}
